import { v4 as uuidv4 } from 'uuid'

export const pickListTypes = [...new Array(5)].map((_: any, index: number) => ({
  id: uuidv4(),
  name: 'Pick List Types ' + ++index,
  __typename: 'PickListType'
}))
